import styled from '@emotion/styled'
import Box from './Box'
import GrooverText from './GrooverText'
import { TextKey } from '../../../pure-js/types/Antiloop'
import { memo } from 'react'

type Props = {
  labelTextKey: TextKey | string
  valueText: string
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const ExpandedActivityDetail = ({ labelTextKey, valueText, onClick }: Props) => (
  <Box fullWidth direction="row" align="center" justify="space-between">
    <GrooverText textKey={labelTextKey} />
    <ActivityDetailValue isLink={!!onClick} onClick={onClick}>
      {valueText}
    </ActivityDetailValue>
  </Box>
)

const ActivityDetailValue = styled(Box)<{ isLink?: boolean }>`
  ${({ isLink }) => isLink && ':hover { cursor: pointer; text-decoration: underline; }'}
`

export default memo(ExpandedActivityDetail)
